const files = require.context('./', false, /\.(svg|png)$/);
files.keys().forEach(files);
